// GENERATED by scripts/build-icons.mjs from icons/arrow-left.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const ArrowLeft = createIcon('arrow-left', [
  ['path', { d: "m12 19-7-7 7-7" }],
  ['path', { d: "M19 12H5" }],
])
